import { motion } from "framer-motion";
import type { ReactNode } from "react";

const EASE = [0.22, 1, 0.36, 1] as const;

interface RevealProps {
  children: ReactNode;
  delay?: number;
  className?: string;
}

export const Reveal = ({ children, delay = 0, className }: RevealProps) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

interface MaskedLinesProps {
  lines: ReactNode[];
  className?: string;
  lineClassName?: string;
  animate?: boolean;
  baseDelay?: number;
}

export const MaskedLines = ({
  lines,
  className,
  lineClassName,
  animate = true,
  baseDelay = 0.2,
}: MaskedLinesProps) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block will-change-transform ${lineClassName ?? ""}`}
          initial={{ y: "115%" }}
          {...(animate
            ? { animate: { y: "0%" } }
            : { whileInView: { y: "0%" }, viewport: { once: true } })}
          transition={{ duration: 1.05, delay: baseDelay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
